<div class="example-container mat-elevation-z8">
  <div class="example-table-container">
    <table mat-table class="example-table" [dataSource]="result" >
      <ng-container [matColumnDef]="column" *ngFor="let column of gridColumns">
        <th mat-header-cell *matHeaderCellDef> {{printCol(column)}} </th>
        <td mat-cell *matCellDef="let element" [ngClass]="'td_width '+column">
          {{printElement(column,element)}}
          <mat-icon *ngIf="column == 'Azioni'" class="green" (click)="dettaglioCorso(element)"
            matTooltip="Visualizza dettaglio corso">search</mat-icon>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="gridColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: gridColumns;" style="height:24px !important;"></tr>
    </table>
  </div>
  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10]" (page)="onPaginateChange($event)"
    [length]="paginatorSize" [pageIndex]="pageIndex" showFirstLastButtons></mat-paginator>
</div>
